<template>
  <div class="opc-succezz-layout" role="main">
    <div class="opc-succezz-layout__top">
      <div class="opc-succezz-layout__top__inner">
        <zm-row>
          <zm-col :span="16">
            <div class="opc-succezz-layout__top-left">
              <slot />
              <div class="opc-succezz-layout__bottom">
                <div class="opc-succezz-layout__bottom__inner">
                  <slot name="promotes" />
                </div>
              </div>
            </div>
          </zm-col>
          <zm-col :span="8">
            <div class="opc-succezz-layout__top-right">
              <slot name="details" />
              <slot name="feedback" />
            </div>
          </zm-col>
        </zm-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('opc-succezz__body');
  }
}
</script>

<style lang='scss'>
@import "./style/header.scss";
</style>

<style lang="scss" scoped>
.opc-succezz-layout {
  $width: 1500px;
  $space: 24px;
  margin: 0 auto;
  &__top {
    background: #fff;
    display: flex;
    justify-content: center;

    &__inner {
      max-width: $width;
      margin: 64px 164px;
      flex: 1;
    }
    &-left {
      padding-right: 180px;
    }
    &-right {
    }
  }
  &__bottom {
    &__inner {
      margin: 0 auto;
    }
  }
}
</style>
